module.exports = __webpack_public_path__ + "static/img/icons8-share.85e360d5.svg";